module.exports = __webpack_public_path__ + "static/media/md-grid.4199c4aa.svg";